import * as React from 'react';
import { ETrackedDeviceProperty } from '../vrhtml';
import { Transform } from "./transform";
import { TRSTransform } from '../utils/transform';

interface ComponentTransformProps
{
	id?: string;
	sDevicePath: string;
	sInputPath: string;
}

interface ComponentTransformState
{
	xfTransform?: TRSTransform;
}

export class ComponentTransform extends React.Component<ComponentTransformProps, ComponentTransformState>
{
	constructor( props: any )
	{
		super( props );

		let newState: ComponentTransformState = {};

		if ( VRHTML )
		{
			try
			{
				let sRenderModelName = VRHTML.VRProperties.GetStringProperty( this.props.sDevicePath, ETrackedDeviceProperty.RenderModelName_String );
				if ( sRenderModelName )
				{
					let sComponent = VRHTML.VRRenderModelsInternal.FindComponentForInputSource( sRenderModelName, this.props.sInputPath );
					if ( sComponent )
					{
						let componentState = VRHTML.VRRenderModels.GetComponentStateForDevicePath( sRenderModelName, sComponent, this.props.sDevicePath );
						if ( componentState )
						{
							newState.xfTransform = componentState.xfTrackingToComponentLocal;
						}
					}
				}
			}
			catch ( error )
			{
				console.log( "Component transform invalid for ", this.props.sDevicePath );
			}
		}

		this.state = newState;
	}

	public render()
	{
		return (
			<Transform id={ this.props.id } parent_path={ this.props.sDevicePath } transform={ this.state.xfTransform }>
				{ this.props.children }
			</Transform>
		);
	}
}
